import { Routes } from 'constants/routeConstants';
import { USER_ROLE } from 'constants/userRoles';

export const LOGO_PATH_BY_ROLE = {
  [USER_ROLE.ADMIN]: Routes.HOME,
  [USER_ROLE.MANAGER]: Routes.HOME,
  [USER_ROLE.CLIENT]: Routes.MY_ACCOUNTS,
};
